export const ACTION_SAVE_TRANSACTIONS_PAGINATED = 'ACTION_SAVE_TRANSACTIONS_PAGINATED';

export const ACTION_SAVE_TRANSACTION_DETAIL = 'ACTION_SAVE_TRANSACTION_DETAIL';

export const ACTION_SAVE_SIMILAR_TRANSACTIONS = 'ACTION_SAVE_SIMILAR_TRANSACTIONS';

export const ACTION_SAVE_TRANSACTION_INSTALLMENTS = 'ACTION_SAVE_TRANSACTION_INSTALLMENTS';

export const ACTION_SAVE_FEE_PAYER = 'ACTION_SAVE_FEE_PAYER';